import tippy from 'tippy.js';

export function init() {
  const helperIcons = document.querySelectorAll('.helper-icon');

  helperIcons.forEach(icon => {
    const iconTooltip = new tippy(icon, { allowHTML: true, arrow: true });
    const content = document.querySelector(icon.dataset.titleTemplate);

    content.classList.remove('hidden');
    content.remove();

    iconTooltip.setContent(content);
  });
}
